module.exports = __webpack_public_path__ + "img/aeroland-tab-content-image-01.f2188cfa.jpg";